// src/App.js

import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import React from 'react';
import { PiArrowUpRightBold, PiCaretRightBold } from "react-icons/pi";
import { Navbar } from './functions/ui';
import Signup from './views/signup';
import Login from './views/login';
import Dashboard from './views/dashboard';
import ProtectedRoute from './views/protectedRoute';
import ShiftCall from './views/shiftcall';
import ShiftInfo from './views/shift-info';
import Staff from './views/staff';
import Onboard from './views/onboard';
import home from './assets/home.png';
import top from './assets/top.png';
import ai from './assets/ai.png';
import clocking from './assets/clocking.png';
import view from './assets/view.png';
import auto from './assets/auto.png';
import google from './assets/google.png';
import apple from './assets/apple.png';
import volta from './assets/volta.png';
import adisson from './assets/adisson.jpg';
import lab from './assets/lab.png';
import bounce from './assets/bounce.png';
import mce from './assets/mce.png';
import genesis from './assets/genesis.png';
import PrivacyPolicy from './views/privacy';
import ViewShifts from './views/view';
import Chat from './views/chat';
import './webapp.css';
import './App.css';
import { trackPageview } from './ga';

// inline title updater: simple, no extra files
function TitleUpdater() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    const map = [
      { match: '/dashboard/shiftcall', title: 'ShiftCall | Kierep' },
      { match: '/dashboard/chat', title: 'Chat | Kierep' },
      { match: '/dashboard/shift-info', title: 'Shift Info | Kierep' },
      { match: '/dashboard/staff', title: 'Staff | Kierep' },
      { match: '/dashboard/view', title: 'View Shifts | Kierep' },
      { match: '/dashboard', title: 'Dashboard | Kierep' },
      { match: '/signup', title: 'Sign Up | Kierep' },
      { match: '/login', title: 'Login | Kierep' },
      { match: '/onboard', title: 'Onboard | Kierep' },
      { match: '/privacy', title: 'Privacy Policy | Kierep' },
      { match: '/', title: 'Kierep | AI-powered quick shift coverage tool for homecare agencies' },
    ];

    const entry = map.find(m => pathname === m.match || pathname.startsWith(m.match + '/')) || map.find(m => m.match === '/') ;
    document.title = entry ? entry.title : 'Kierep';
  }, [pathname]);
  return null;
}

// GA pageview tracker
function GATracker() {
  const location = useLocation();
  React.useEffect(() => {
    const path = location.pathname + (location.search || '');
    trackPageview(path);
  }, [location]);
  return null;
}

function Home() {
  const navigate = useNavigate();

  const handleGotoAccount = () => {
    navigate('/login');
  };

  return (
    <div>
      <Navbar />
      <div className="body-box">
        <div className="body-box-2 first-box">
          <div className="first-box-1">
            <h1 className="title-text">
              Fill dropped shifts with automation
            </h1>
            <h3 className="sub-text">
              Instantly broadcast dropped shifts to staff. <br />
              Use AI to probe staff and shift information <br />for better business decisions.</h3>
            <div className="spacer-for-buttons" />
            <button className="mini-button mini-button-home" onClick={handleGotoAccount}>
              <p>Create an account</p> <PiCaretRightBold />
            </button>
          </div>
          <div className="first-box-2">
            <img src={top} alt="top" className="home-image" />
          </div>
        </div>
      </div>

      <div className="removable body-box">
        <div className=" body-box-3 second-box">
          <h1 className="header-text">Secure, safer than emails or SMS </h1>
          <p className="sub-text">Kierep operates on a secure database built to protect sensitive client data, giving agencies the confidence that their client information is always safe and compliant.</p>
        </div>
      </div>

      <div className="body-box">
        <div className="body-box-2">
          <div className="image-box image-box-left">
            <img src={ai} alt="ai" className="ai" />
          </div>
          <div className='box-space' />
          <div className="text-box">
            <h1 className="header-text">
              Make better business decisions with AI
            </h1>
            <h3 className="sub-text">
              Use AI to analyze staff performance and shift trends, giving you the data- <br />driven clarity to make smarter decisions, everyday.
            </h3>
            <a href="/signup" className="learn-more">
              <p className="learn-more-text">Log in to account</p>
              <PiArrowUpRightBold size={12} />
            </a>
          </div>
        </div>
      </div>

      <div className="body-box color-2-body-box">
        <div className="body-box-2">
          <div className="text-box">
            <h1 className="header-text">
              Introducing the Kierep staff app
            </h1>
            <h3 className="sub-text">
              With 99.99% historical uptime for filling shifts, Kierep automates sending dropped shifts with real-time push alerts, and attendance is tracked automatically for flawless records. With self-onboarding via agency codes, teams join faster, and care gets delivered without delay.
            </h3>
            <div className="spacer-for-buttons" />
            <div className="store-buttons">
              <a href="https://apps.apple.com/ca/app/kierep-for-staff/id6695726140" target="_blank" rel="noopener noreferrer">
                <img src={apple} alt="Download on the App Store" className="store-badge" />
              </a>
              <a href="https://www.kierep.com" >
                <img src={google} alt="Get it on Google Play" className="store-badge" />
              </a>
            </div>
          </div>
          <div className='box-space' />
          <div className="image-box">
            <img src={home} alt="section-image" className="section-image-1" />
          </div>
        </div>
      </div>

      <div className="body-box">
        <div className="body-box-2">
          <div className="image-box image-box-left">
            <img src={auto} alt="auto" className="section-image" />
          </div>
          <div className='box-space' />
          <div className="text-box">
            <h1 className="header-text">
              Communicate open shift with push notification automation
            </h1>
            <h3 className="sub-text">
              Introducing the first homecare software built to automate open shift communication. Instead of cold calls or endless emails, staff receive real-time push alerts for every new or dropped shift, boosting attendance, and ensuring clients get the care they need without delay.
            </h3>
            <a href="https://apps.apple.com/ca/app/kierep-for-staff/id6695726140" className="learn-more">
              <p className="learn-more-text">Learn more</p>
              <PiArrowUpRightBold size={12} />
            </a>
          </div>
        </div>
      </div>

      <div className="body-box color-3-body-box">
        <div className="body-box-2">
          <div className="text-box">
            <h1 className="header-text">
              Fail-Safe Clock In/Out Reminders
            </h1>
            <h3 className="sub-text">
              We ensure no shift is ever missed by reminding staff to clock in/out at the right time, even if the app isn’t open or there’s no internet connection. The result is fewer calls to scheduling, less manual correction, fewer payroll errors, and clean, dependable records for every single shift.</h3>
            <a href="https://apps.apple.com/ca/app/kierep-for-staff/id6695726140" className="learn-more">
              <p className="learn-more-text">Learn more</p>
              <PiArrowUpRightBold size={12} />
            </a>
          </div>
          <div className='box-space' />
          <div className="image-box">
            <img src={clocking} alt="section-image" className="section-image-1" />
          </div>
        </div>
      </div>

      <div className="body-box">
        <div className="body-box-2">
          <div className="image-box image-box-left">
            <img src={view} alt="view" className="section-image" />
          </div>
          <div className='box-space' />
          <div className="text-box">
            <h1 className="header-text">
              Empower staff with seamless navigation
            </h1>
            <h3 className="sub-text">
              When you use Kierep, staff can instantly get directions to their assigned shift locations directly from the app. No confusion, no wasted time — just one tap and they are on the fastest route to work, keeping your team punctual and your operations smooth.
            </h3>
            <a href="https://apps.apple.com/ca/app/kierep-for-staff/id6695726140" className="learn-more">
              <p className="learn-more-text">Learn more</p>
              <PiArrowUpRightBold size={12} />
            </a>
          </div>
        </div>
      </div>

      <div className="body-box">
        <div className="body-box-2">
          <div className="text-box">
            <h1 className="header-text">
              Staff-led onboarding
            </h1>
            <h3 className="sub-text">
              With a unique code generated for your agency, frontline staff can onboard themselves, cutting management workload, admin delays, increasing onboarding speed by 2x.
            </h3>
            <a href="/signup" className="learn-more">
              <p className="learn-more-text">Learn more</p>
              <PiArrowUpRightBold size={12} />
            </a>
          </div>
          <div className='box-space' />
          <div className="image-box">
            <h1 className="numbers">13AC_&lt; </h1>
          </div>
        </div>
      </div>

      {/* <div className="fourth-home">
        <h1>Testimonials</h1>
        <div className="fourth-box-1">
          <div className="fourth-box-11">
            <h2>Temilorun Omonojo</h2>
            <p>I was priviledged to meet with the recruiter from Provincial Homecare through Kierep. I followed up and was offered a job few weeks later.</p>
          </div>
          <div className="fourth-box-12">
            <h2>Evelyn Adadziwa</h2>
            <p>Kierep was relentless in placing me in the job market. Their initiative was timely and provided the stepping stone I needed in my career.</p>
          </div>
        </div> */}

      <div className="body-box">
        <div className="supported-box">
          <h1>Supported by</h1>
          <div className="support-box">
            <img src={genesis} alt="Genesis" className="support-image" />
            <img src={mce} alt="MCE" className="support-image" />
            <img src={volta} alt="Volta" className="support-image" />
            <img src={adisson} alt="Adisson" className="support-image" />
            <img src={bounce} alt="Bounce" className="support-image" />
            <img src={lab} alt="Lab" className="support-image" />
          </div>
        </div>
      </div>

      <div className="body-box">
        <div className="body-box-2">
          <p className="bottom-text">
            © 2025 Kierep Enterprise | All Rights Reserved
          </p>
        </div>
      </div>

    </div>
  );
}

// App Component
function App() {
  return (
    <Router>
      <TitleUpdater />
      <GATracker />
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Home />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/login" element={<Login />} />
        <Route path="/onboard" element={<Onboard />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />

        {/* Protected Dashboard Routes */}
        <Route path="/dashboard" element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }>
          <Route path="shiftcall" element={
            <ProtectedRoute>
              <ShiftCall />
            </ProtectedRoute>
          } />
          <Route path="chat" element={
            <ProtectedRoute>
              <Chat />
            </ProtectedRoute>
          } />
          <Route path="shift-info" element={
            <ProtectedRoute>
              <ShiftInfo />
            </ProtectedRoute>
          } />
          <Route path="staff" element={
            <ProtectedRoute>
              <Staff />
            </ProtectedRoute>
          } />
          <Route path="view" element={
            <ProtectedRoute>
              <ViewShifts />
            </ProtectedRoute>
          } />
          {/* Default route within dashboard (redirect to Applicants) */}
          <Route index element={<Navigate to="/dashboard/shiftcall" />} />
        </Route>

        {/* Default redirection from root to dashboard applicants */}
        <Route path="/" element={<Navigate to="/dashboard/shiftcall" />} />
      </Routes>
    </Router>
  );
}

export default App;